/* Header — drawer, zoekoverlay en submenu's.
   Zonder JavaScript blijven alle menulinks bereikbaar via de drawer-markup;
   dit script regelt alleen openen, sluiten en focusbeheer. */

(function () {
  'use strict';

  var openPanel = null;
  var lastTrigger = null;

  function focusables(el) {
    return el.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  function open(name, trigger) {
    var panel = document.querySelector('[data-dk-panel="' + name + '"]');
    if (!panel) return;

    close();

    panel.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    openPanel = panel;
    lastTrigger = trigger || null;

    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var auto = panel.querySelector('[data-dk-autofocus]');
    var first = auto || focusables(panel)[0];
    if (first) first.focus();
  }

  function close() {
    if (!openPanel) return;

    openPanel.hidden = true;
    document.documentElement.style.overflow = '';

    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus();
    }

    openPanel = null;
    lastTrigger = null;
  }

  function trapFocus(event) {
    if (!openPanel || event.key !== 'Tab') return;

    var items = focusables(openPanel);
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-dk-open]');
    if (opener) {
      event.preventDefault();
      open(opener.dataset.dkOpen, opener);
      return;
    }

    if (event.target.closest('[data-dk-close]')) {
      event.preventDefault();
      close();
      return;
    }

    // Klik op de donkere achtergrond naast het drawerpaneel sluit de drawer.
    if (openPanel && openPanel.classList.contains('dk-drawer') && event.target === openPanel) {
      close();
      return;
    }

    var submenu = event.target.closest('[data-dk-submenu]');
    if (submenu) {
      var expanded = submenu.getAttribute('aria-expanded') === 'true';
      var list = submenu.nextElementSibling;
      submenu.setAttribute('aria-expanded', String(!expanded));
      if (list) list.hidden = expanded;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    trapFocus(event);
  });

  // Panelen sluiten wanneer het scherm naar desktop gaat.
  var wide = window.matchMedia('(min-width: 768px)');
  function sync() { if (wide.matches) close(); }
  if (wide.addEventListener) {
    wide.addEventListener('change', sync);
  } else if (wide.addListener) {
    wide.addListener(sync);
  }

  document.addEventListener('shopify:section:load', close);

  /* Zoeksuggesties -------------------------------------------------------
     Het veld is een combobox. De resultaten komen uit de sectie
     dirksen-predictive-search, opgehaald via de Predictive Search API, zodat
     de prijzen door de money-filter van Liquid gaan en niet hier worden
     opgemaakt. Zonder dit script blijft het formulier gewoon werken. */

  function setupSearch(input) {
    if (input.dataset.dkReady === '1') return;
    input.dataset.dkReady = '1';

    var box = document.getElementById(input.getAttribute('aria-controls'));
    if (!box || !window.routes || !window.routes.predictive_search_url) return;

    var timer = null;
    var controller = null;
    var index = -1;

    function options() {
      return box.querySelectorAll('[role="option"]');
    }

    function closeBox() {
      box.hidden = true;
      box.innerHTML = '';
      index = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function highlight(next) {
      var items = options();
      if (!items.length) return;
      if (index >= 0 && items[index]) items[index].setAttribute('aria-selected', 'false');
      index = (next + items.length) % items.length;
      var current = items[index];
      current.setAttribute('aria-selected', 'true');
      if (current.id) input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
    }

    function query(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = window.routes.predictive_search_url
        + '?q=' + encodeURIComponent(term)
        + '&resources[type]=product,collection&resources[limit]=6'
        + '&section_id=dirksen-predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('zoeken mislukte');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var results = parsed.querySelector('.dk-suggest');
          if (!results) {
            closeBox();
            return;
          }
          box.innerHTML = '';
          box.appendChild(results);
          box.hidden = false;
          index = -1;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {
          // Afgebroken door een nieuwe toetsaanslag, of mislukt: niets tonen.
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (timer) window.clearTimeout(timer);
      if (term.length < 2) {
        closeBox();
        return;
      }
      timer = window.setTimeout(function () { query(term); }, 250);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeBox();
        return;
      }
      if (box.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        highlight(index + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(index - 1);
      } else if (event.key === 'Enter' && index >= 0) {
        var link = options()[index].querySelector('a');
        if (link) {
          event.preventDefault();
          window.location.href = link.href;
        }
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target !== input && !box.contains(event.target)) closeBox();
    });
  }

  function initSearch() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-dk-search-input]'),
      setupSearch
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch, { once: true });
  } else {
    initSearch();
  }

  document.addEventListener('shopify:section:load', initSearch);
})();
